<script lang="ts" setup>
import LiveStatus from "@/components/status/LiveStatus.vue";
import { useRouteInfo } from "@/composable/route-info";
import { Station } from "@soft-db/monitoring-api-client";
import { Progress } from "@soft-db/ui";
import Header from "./Header.vue";
import Info from "./Info.vue";
import Links from "./Links.vue";
import Location from "./Location.vue";

const emit = defineEmits(["close"]);
defineProps({
	station: { type: Object as PropType<Station>, required: true },
	isLoading: Boolean,
});

const { currentRoute } = useRouteInfo();
const page = computed(() => {
	switch (currentRoute.value) {
		case "dashboard":
			return "dashboard";

		case "integrity":
			return "integrity";

		case "site":
		case "station":
			return "settings";

		default:
			return "map";
	}
});
</script>

<template>
	<div class="bg-base-100 min-w-80 rounded-t-3xl px-2 py-1 shadow-md md:rounded-md">
		<Progress v-if="isLoading" class="w-full" color="primary" />
		<template v-else>
			<Header objectType="station" :title="station.name" @close="() => emit('close')" />
			<Info
				sourceType="station"
				:sourceId="station.id"
				:description="station.description"
				noImage
			/>
			<Location v-if="station.coordinates" :coordinates="station.coordinates" />
			<LiveStatus sourceType="station" :sourceId="station.id" class="flex w-full py-1" xs />
			<Links :page="page" :station="station" />
		</template>
	</div>
</template>
